<template>
  <div>
    <navigation />
  </div>
</template>

<script>
  import navigation from './navigation'
  export default {
    name: 'login',
    components: {
      'navigation': navigation,
    },

    created() {
      let token = this.$route.params.token
      if (token != undefined) {
        let canIds = this.$cookies.get('can-ids')
        canIds = canIds != null ? canIds.split(',') : []
        this.axios.post(this.api.checkLogin + '/' + token, {
          canIds: canIds
        }).then(results => {
          let res = results.data
          if (res.code == 0) {
            let user = {
              token: res.data.token,
              nickName: res.data.nickName
            }
            this.$cookies.set('user', user, 0)
            this.$cookies.remove('can-ids')
            let lastPath = this.$cookies.get('last-path')
            if (lastPath && lastPath.path != null) {
              this.$router.push({
                path: lastPath.path
              })
            } else {
              if (this.$route.name != 'index') {
                this.$router.push({
                  path: '/index'
                })
              } else {
                location.reload();
              }
            }
          }
        })
      }

    }

  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/login.vue